import script from "./PageController.vue?vue&type=script&setup=true&lang=js"
export * from "./PageController.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__